<template>
  <div class="relative z-20">
    <transition name="fade">
      <div
        @click="onClickOutside"
        class="fixed inset-0 hidden bg-base-100 opacity-40 md:block"
      />
    </transition>
    <transition
      name="individual-report-transition"
      enter-active-class="animate__animated animate__slideInRight animate__faster"
      leave-active-class="animate__animated animate__slideOutRight animate__faster"
    >
      <div
        class="individual-report"
        v-click-outside="onClickOutside"
      >
        <slot name="content">
        </slot>
      </div>
    </transition>
    <button type="button" class="button-close" @click="onClickOutside">
      <aha-icon name="close" />
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    onClickOutside() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss-v2/variables.scss";
.button-close{
  @apply fixed cursor-pointer flex items-center justify-center bg-base-0;
  top:24px;
  right: 732px;
  width: 36px;
  height:36px;
  border-radius: 50%;
  z-index:20;
  &:hover{
    color: #348EF6;
  }

  @media (max-width: 768px) { // sm screens
    top: 12px;
    right: 12px;
  }
}
.individual-report {
  overflow: visible;
  @apply w-full transition-all shadow-top bg-no-repeat h-full fixed right-0 overflow-y-scroll;
  @apply top-0;
  background: #F0F4FA;
  background-size: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;  /* Hide scrollbar on IE and Edge */
  scrollbar-width: none;
  @media (min-width: 768px) { // sm screens
    min-height: calc(100vh); // header height is 4rem
    width: 720px;
  }

}

</style>
